module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/cinnamon@3x_8e447d.jpg";